/** /geo 渠道包（渠道号 6187 / 3796） */
export const GEO_PC_DOWNLOAD =
  "https://static.dhsf.996box.com/box/channel_app/996box503SetupSigned@6187.exe";
export const GEO_ANDROID_DOWNLOAD =
  "https://static.dhsf.996box.com/box/channel_app/1780393202_wDmXEhfyf7.apk";

export const BAIDU_PC_DOWNLOAD =
  "//static.dhsf.996box.com/box/channel_app/996boxSetup@6118.exe";

export function isGeoRoute(route: any): boolean {
  const query = route && route.query;
  return (
    route.name === "geo" ||
    route.path === "/geo" ||
    (query && query.isCom === "/geo")
  );
}

export function isBaiduPinzhuanRoute(route: any): boolean {
  const query = route && route.query;
  return (
    route.name === "baidu" ||
    route.path === "/baidu" ||
    (query && query.isCom === "/baidu")
  );
}

export function getPinzhuanPcDownloadUrl(route: any): string {
  if (isGeoRoute(route)) return GEO_PC_DOWNLOAD;
  return BAIDU_PC_DOWNLOAD;
}

export function getPinzhuanAndroidDownloadUrl(route: any): string {
  if (isGeoRoute(route)) return GEO_ANDROID_DOWNLOAD;
  return "https://static.dhsf.xqhuyu.com/temporary_file/1650768807000_rDAx2.apk";
}
